import { UserExportVO } from './../../model/user-export-vo';
import { ExportService } from './../../service/export.service';
import {Component, OnInit, Input, ViewChild, AfterViewChecked} from '@angular/core';
import {SessionService} from '../../service/SessionService';
import {AlertService} from "../../service/alert.service";
import {MatDialogRef, MatSelectionList, MatSelectionListChange} from '@angular/material';
import {ExportDialogComponent} from '../intelcia-tree/export-dialog/export-dialog.component';

@Component({
  selector: 'app-export',
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.css']
})
export class ExportComponent implements OnInit, AfterViewChecked {
  _iseExport = false;
  maxDay = 1;
  minDate = null;
  maxDate = null;
  _useList = false;
  startDate;
  endDate;
  _siteId;
  _session;
  _teamIds;
  _usersExport: Array<UserExportVO> = [];
  isMultiple;
  _lists = [];
  _isDisabled = true;
  @ViewChild('sitesList') sitesList: MatSelectionList;
  @Input()
  set useList(_useList) {
    this._useList = _useList;
  }
  @Input()
  set List(_lists) {
    this._lists = _lists;
  }
  @Input()
  set isMultipleExport(isMultipleExport) {
    this.isMultiple = isMultipleExport;
  }

  @Input()
  set agents(agents) {
    // console.log(agents)
    this.alertService.clearById('0');
    this._usersExport = [];
    if (agents.length > 0) {
      this._siteId = agents[0].site;
      this._session = agents[0].session;
      // console.log(agents[0])
      agents.forEach(agent => {
        this._usersExport.push(new UserExportVO(agent.username, agent.team));
      });
    }
  }

  getAlertId() {
    return this.isMultiple == "false" ? this._usersExport[0].userName : '0';
  }

  constructor(private exportService: ExportService,
              private session: SessionService,
              private alertService: AlertService,
              public dialogRef: MatDialogRef<ExportDialogComponent>) {
  }
  close() {
  this.dialogRef.close()
  }
  submit(formExport) {
    this.startDate = formExport.value.startDate;
    // console.log(this.startDate);
    this.endDate = formExport.value.endDate;
    // console.log(this.endDate);
    const exportFilter = {
      usersExport: this._usersExport,
      siteId: this._siteId != null ? this._siteId : '',
      session: this._session != null ? this._session : '',
      sessionId: null,
      exporter: null,
      exportIP4: false,
      exportId: null,
      debut: this.startDate.getTime(),
      fin: this.endDate.getTime(),
      siteFormation: null
    };
   this.exportService.process(exportFilter).subscribe(response => {
      // console.log(response);
    }, error1 => {
      this.session.redirectBadRequest(error1);
    });
  }
  submitBySites(formExport) {
    this._iseExport = true
    const start = this.startDate = new Date(formExport.value.startDate).getTime();
    const end  = this.endDate = new Date(formExport.value.endDate).getTime();
    const siteId = this.sitesList.selectedOptions.selected[0].value;
    const site = this._lists.filter( e => e.id === siteId)[0];
    const toData = {siteId, start, end};
    this.exportService.processSite(toData).subscribe((response: any) => {
      if(response._body == 'ok') {
        this.dialogRef.close()
      }
    }, error1 => {
      this.session.redirectBadRequest(error1);
    });
  }
  success(message: string, alertId: string) {
    this.alertService.success(message, alertId);
  }
  successBySite(message: string, alertId: string) {
    this.alertService.success(message, alertId);
  }

  ngOnInit() {
    this.exportService.maxDay().subscribe((day: any) => {
      this.maxDay = parseInt(day._body);
    })
  }
  ngAfterViewChecked() {
    if(this.sitesList) {
      this.sitesList.selectionChange.subscribe((s: MatSelectionListChange) => {
        this.sitesList.deselectAll();
        // console.log(s.option.value)
        s.option.selected = !s.option.selected;
      });
    }
  }
  getsitesList(){
    return (this.sitesList ? this.sitesList.selectedOptions.selected.length == 0:  true);
  }

  setDuration(e) {
    this._isDisabled = false
    const d = new Date(e.value);
    this.minDate = d;
    d.setDate(d.getDate() + this.maxDay);
    this.maxDate = d;
  }
}



// WEBPACK FOOTER //
// ./src/app/view/export/export.component.ts